<template>
  <el-row class="participation-goods">
    <el-col
      :span="24"
      class="col-span"
    >
      <div class="column-title">参加优惠商品设置</div>
    </el-col>
    <el-col :span="24">
      <el-form-item
        label="参与商品"
        prop="participationType"
        label-width="120px"
      >
        <el-select
          v-model="participationType"
          @change="participationTypeChange"
        >
          <el-option
            label="全部商品"
            value="10"
          ></el-option>
          <el-option
            label="指定分类"
            value="20"
          ></el-option>
          <el-option
            label="指定商品"
            value="30"
          ></el-option>
        </el-select>
      </el-form-item>
    </el-col>
    <el-col
      :span="24"
      v-show="participationType != '10'"
    >
      <el-form-item
        label="参与商品"
        prop="participationType"
        label-width="120px"
      >
        <el-tabs v-model="participationType">
          <el-tab-pane
            label="指定分类"
            name="20"
            disabled
          >
            <el-tree
              ref="categoryTree"
              :check-on-click-node="true"
              :data="categoryList"
              show-checkbox
              node-key="value"
              :default-checked-keys="categoryIds"
              :props="defaultTreeProps"
            >
            </el-tree>
          </el-tab-pane>
          <el-tab-pane
            label="指定商品"
            name="30"
            disabled
          >
            <list-template
              v-show="participationGoodsList && participationGoodsList.length > 0"
              :tableData="participationGoodsList"
              :tableOptions="tableOptions"
              :toolConfig="toolConfig"
            ></list-template>
             <el-button
              @click="showGoodsList"
            >选择商品</el-button>
          </el-tab-pane>
        </el-tabs>
      </el-form-item>
    </el-col>
    <el-col
      :span="24"
      v-show="participationType != '30'"
    >
      <el-form-item
        label="不参与商品"
        prop="noParticipationType"
        label-width="120px"
      >
        <el-tabs v-model="noParticipationType">
          <el-tab-pane
            label="指定分类"
            name="20"
            disabled
          >
            <el-tree
              ref="noCategoryTree"
              :check-on-click-node="true"
              :data="categoryList"
              show-checkbox
              node-key="value"
              :default-checked-keys="noCategoryIds"
              :props="defaultTreeProps"
            >
            </el-tree>
          </el-tab-pane>
          <el-tab-pane
            label="指定商品"
            name="30"
            disabled
          >
            <list-template
              v-show="noParticipationGoodsList && noParticipationGoodsList.length > 0"
              :tableData="noParticipationGoodsList"
              :tableOptions="tableOptions"
              :toolConfig="toolConfig"
            ></list-template>
             <el-button
              @click="showNoGoodsList"
            >选择不参加活动商品</el-button>
          </el-tab-pane>
        </el-tabs>
      </el-form-item>
    </el-col>
    <el-dialog
      title="商品列表"
      :visible.sync="listShow"
      width="1200px"
      :modal="false"
      custom-class="participation-dialog"
      :close-on-click-modal="false"
    >
      <good-list
        ref="goodsListOperation"
        :isSelect="goodListSelect"
        :listTableData="listTableData"
        @selectSubmit="rowsSelectSubmit"
      ></good-list>
    </el-dialog>
  </el-row>
</template>
<script>
import api from "@/config/api";
//商品列表组件
import goodList from "@/components/business/goodList";
import listTemplate from "@/components/template/listTemplate.vue";
export default {
  components: { listTemplate, goodList },
  data() {
    return {
      tableOptions: {
        tableName: "goodsTable",
        indexShow: true, //是否显示索引
        indexMethod: (index) => {
          //自定义列索引
          return index + 1;
        },
        columns: [
          {
            label: "条码",
            prop: "barCode",
            width: "200",
            align: "center",
          },
          {
            label: "品名",
            prop: "goodsName",
            width: "150",
            align: "center",
          },
          {
            label: "助记码",
            prop: "artNo",
            width: "150",
            align: "center",
          },
          {
            label: "规格",
            prop: "specs",
            width: "150",
            align: "center",
          },
          {
            label: "单位",
            prop: "unitName",
            width: "200",
            align: "center",
          },
        ],
      },
      // 更多功能
      toolConfig: [
        {
          label: "删除",
          code: "delete",
          type: this.$utils.buttonType.tableOperate,
          callback: this.deleteGoods
        },
      ],
      listTableData: [], // 用于传给选择商品组件，判断是否已被选择
      goodListSelect: false,
      defaultTreeProps: {
        children: "children",
        label: "label",
      },
      categoryList: [],
      participationType: "10", //参加活动类型
      participationGoodsList: [], //参加活动商品
      noParticipationType: "20", //不参加活动类型
      noParticipationGoodsList: [], //不参加活动商品
      listShow: false,
      listType: "participationGoodsList",
      categoryIds: [], //参加活动回填
      noCategoryIds: [], //不参加活动类别回填
      categoryGoodsList: [], //参加活动类别
      noCategoryGoodsList: [], //不参加活动类别
    };
  },
  created() {
    this.getCategoryList();
  },
  methods: {
    setValue(formModel) {
      this.participationType = formModel.participationType.toString(); //参加活动类型
      this.participationGoodsList = formModel.participationGoodsList; //参加活动商品
      this.noParticipationType = formModel.noParticipationType.toString(); //不参加活动类型
      this.noParticipationGoodsList = formModel.noParticipationGoodsList; //不参加活动商品
      this.categoryIds = formModel.categoryIds; //参加活动类别id
      this.noCategoryIds = formModel.noCategoryIds; //不参加活动类别id
      if (this.participationGoodsList !== null) {
        this.listTableData = this.participationGoodsList;
      } else {
        this.listTableData = this.noParticipationGoodsList;
      }
    },
    //删除指定商品列表商品
    deleteGoods(row) {
      if (this.participationGoodsList !== null){
        for (let i = 0; i < this.participationGoodsList.length; i++) {
          if (row === this.participationGoodsList[i]) {
            this.participationGoodsList.splice(i, 1);
          }
        }
      }else {
        for (let i = 0; i < this.noParticipationGoodsList.length; i++) {
          if (row === this.noParticipationGoodsList[i]) {
            this.noParticipationGoodsList.splice(i, 1);
          }
        }
      }
    },
    getAllData() {
      this.categoryGoodsList = this.$refs.categoryTree.getCheckedKeys();
      this.noCategoryGoodsList = this.$refs.noCategoryTree.getCheckedKeys();
      return {
        participationType: this.participationType, //参加活动类型
        participationGoodsList: this.participationGoodsList, //参加活动商品
        noParticipationType: this.noParticipationType, //不参加活动类型
        noParticipationGoodsList: this.noParticipationGoodsList, //不参加活动商品
        categoryIds: this.categoryGoodsList, //参加活动类别id
        noCategoryIds: this.noCategoryGoodsList, //不参加活动类别id
      };
    },
    showGoodsList() {
      this.listType = "participationGoodsList";
      this.listShow = true;
      this.goodListSelect = true;
      this.listTableData = this.participationGoodsList;
      this.$nextTick(() => {
        this.$refs.goodsListOperation.getTableData();
        this.selectedGoods();
      });
    },
    showNoGoodsList() {
      this.listType = "noParticipationGoodsList";
      this.listShow = true;
      this.goodListSelect = true;
      this.listTableData = this.noParticipationGoodsList;
      this.selectedGoods();
    },
    //已选商品传入商品组件
    selectedGoods(){
      this.$refs.goodsListOperation.toggleRowSelection(this.listTableData.find(item => {
        return row.id === item.id
      }), true)
    },
    rowsSelectSubmit(rows) {
      this.listShow = false;
      this[this.listType].push(...rows);
    },
    participationTypeChange() {
      switch (this.participationType) {
        case "10":
          this.noParticipationType = "20";
          break;
        case "20":
          this.noParticipationType = "30";
          break;
        case "30":
          this.noParticipationType = "10";
          break;
      }
    },
    getCategoryList() {
      this.$axios
        .fetchPost(api.archives.getCategoryTree + "/list")
        .then((res) => {
          if (res.code === 200) {
            this.categoryList = res.data;
          } else {
            this.$message.error(res.errorMsg);
          }
        });
    },
  },
};
</script>
<style>
.participation-goods .el-tabs__item {
  height: 30px;
  line-height: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/business/participationGoods.vue